import api from "./api";

export const logEvent = (event, meta = {}) => {
  api.post("/analytics/event", { event, meta }).catch(() => {});
};
